import type { IconData } from '@stacksjs/iconify-core'

export const userManLove: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M20.575 7.62h1.52v1.52h1.52v1.52h1.53V9.14h1.52V7.62h1.53V6.09h1.52V3.04h-1.52V1.52h-1.53v1.52h-1.52v1.53h-1.53V3.04h-1.52V1.52h-1.52v1.52h-1.53v3.05h1.53zm-6.1 7.61h1.53v9.15h-1.53Zm-1.52-1.52h1.52v1.52h-1.52Z\"/><path fill=\"currentColor\" d=\"M12.955 18.28h-1.53v3.05h-4.57v-3.05h-1.52v6.1h-1.53v1.52h1.53V32h3.05v-4.58h1.52V32h3.05v-6.1h1.52v-1.52h-1.52zm-1.53-6.09h1.53v1.52h-1.53Zm0-3.05h1.53v1.52h-1.53Zm-3.04 4.57h1.52v4.57h-1.52Zm-1.53-3.05h4.57v1.53h-4.57Zm-1.52 1.53h1.52v1.52h-1.52Zm0-3.05h1.52v1.52h-1.52Zm-1.53 4.57h1.53v1.52h-1.53Zm3.05-7.62V4.57h4.57v1.52h1.53v3.05h1.52v-6.1h-1.52V1.52h-1.53V0h-4.57v1.52h-1.52v1.52h-1.53v6.1h1.53V6.09zm-4.57 9.14h1.52v9.15h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default userManLove
